import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseInputComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_MONTH_INPUT_TYPE = 'postermywall-month-input';

export const POSTERMYWALL_MONTH_INPUT: AddComponentTypeOptions = createBaseInputComponent({
  inputFieldType: POSTERMYWALL_MONTH_INPUT_TYPE,
  inputName: 'month',
  dataMarkerAttribute: 'data-is-pmw-form-birthday-input',
  displayName: 'Birthday',
  placeholder: 'MM',
  style: FORM_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-birthday-input') !== null && el.getAttribute('name') === 'month',
  additionalAttributes: {maxlength: 2, minlength: 2, type: 'number', min: 1, max: 12},
});
